<script>
import {BRow, BCol,} from 'bootstrap-vue'
import {CountersCard, VerticalCounterCard} from "@/views/statistics/components";
import Overlay from "@core/components/common/Overlay.vue";
import {StatisticsApi} from "@core/api";
import SubstanceProductCountTableCard from "@/views/statistics/components/SubstanceProductCountTableCard.vue";

export default {
    components: {
        SubstanceProductCountTableCard,
        Overlay,
        BRow, BCol, CountersCard, VerticalCounterCard
    },
    data() {
        return {
            showLoading: true,
            counters: [],
            requestVerticalCounters: [],
            supplierVerticalCounters: [],
            substanceProductCountData: {data: []},
        }
    },
    methods: {
        calculatePercentage(amount, total) {
            return Math.round(amount / total * 100 * 100) / 100;
        },
        formRequestVerticalCounters(data) {
            this.requestVerticalCounters.push({
                key: 'counter.product.requests.sent.total',
                title: this.$t('Component(Statistics):counter.product.requests.sent.total') ,
                avatar: 'ChevronsRightIcon',
                avatarVariant: 'light-primary',
                payment: data['counter.product.requests.sent.total'].data,
                deduction: false,
            });
            let percentage = 0;
            if (data['counter.product.requests.sent.total'].data > 0) {
                percentage = this.calculatePercentage(
                    data['counter.product.requests.sent.new'].data,
                    data['counter.product.requests.sent.total'].data
                );
            }
            this.requestVerticalCounters.push({
                key: 'counter.product.requests.sent.new',
                title: this.$t('Component(Statistics):counter.product.requests.sent.new') ,
                description: percentage + '%',
                avatar: 'EyeOffIcon',
                avatarVariant: 'light-danger',
                payment: data['counter.product.requests.sent.new'].data,
                deduction: (data['counter.product.requests.sent.approved'].data + data['counter.product.requests.sent.replied'].data) < data['counter.product.requests.sent.new'].data,
            });
            if (data['counter.product.requests.sent.total'].data > 0) {
                percentage = this.calculatePercentage(
                    data['counter.product.requests.sent.replied'].data,
                    data['counter.product.requests.sent.total'].data
                );
            }
            this.requestVerticalCounters.push({
                key: 'counter.product.requests.sent.replied',
                title: this.$t('Component(Statistics):counter.product.requests.sent.replied') ,
                description: percentage + '%',
                avatar: 'BellIcon',
                avatarVariant: 'light-success',
                payment: data['counter.product.requests.sent.replied'].data,
                deduction: false,
            });
            if (data['counter.product.requests.sent.total'].data > 0) {
                percentage = this.calculatePercentage(
                    data['counter.product.requests.sent.approved'].data,
                    data['counter.product.requests.sent.total'].data
                );
            }
            this.requestVerticalCounters.push({
                key: 'counter.product.requests.sent.approved',
                title: this.$t('Component(Statistics):counter.product.requests.sent.approved') ,
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: data['counter.product.requests.sent.approved'].data,
                deduction: false,
            });
        },
        formSupplierVerticalCounters(data) {
            this.supplierVerticalCounters.push({
                key: 'counter.supply-chain.suppliers.contacted',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.contacted') ,
                avatar: 'ChevronsRightIcon',
                avatarVariant: 'light-primary',
                payment: data['counter.supply-chain.suppliers.contacted'].data,
                deduction: data['counter.supply-chain.suppliers.contacted'].data === 0,
            });
            let percentage = 0;
            if (data['counter.supply-chain.suppliers.contacted'].data > 0) {
                percentage = this.calculatePercentage(
                    data['counter.supply-chain.suppliers.logged-in'].data,
                    data['counter.supply-chain.suppliers.contacted'].data
                );
            }
            this.supplierVerticalCounters.push({
                key: 'counter.supply-chain.suppliers.logged-in',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.logged-in') ,
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: data['counter.supply-chain.suppliers.logged-in'].data,
                deduction: data['counter.supply-chain.suppliers.logged-in'].data === 0,
            });
            if (data['counter.supply-chain.suppliers.contacted'].data > 0) {
                percentage = this.calculatePercentage(
                    data['counter.supply-chain.suppliers.opened-product-request'].data,
                    data['counter.supply-chain.suppliers.contacted'].data
                );
            }
            this.supplierVerticalCounters.push({
                key: 'counter.supply-chain.suppliers.opened-product-request',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.opened-product-request'),
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: data['counter.supply-chain.suppliers.opened-product-request'].data,
                deduction: data['counter.supply-chain.suppliers.opened-product-request'].data === 0,
            });
            if (data['counter.supply-chain.suppliers.contacted'].data > 0) {
                percentage = this.calculatePercentage(
                    data['counter.supply-chain.suppliers.replied-product-request'].data,
                    data['counter.supply-chain.suppliers.contacted'].data
                );
            }
            this.supplierVerticalCounters.push({
                key: 'counter.supply-chain.suppliers.replied-product-request',
                title: this.$t('Component(Statistics):counter.supply-chain.suppliers.replied-product-request'),
                description: percentage + '%',
                avatar: 'CheckIcon',
                avatarVariant: 'light-success',
                payment: data['counter.supply-chain.suppliers.replied-product-request'].data,
                deduction: data['counter.supply-chain.suppliers.replied-product-request'].data === 0,
            });
        },
        formGeneralCounters(data) {
            this.counters.push({
                key: 'counter.product.scip-notifications.succeeded',
                icon: 'UploadCloudIcon',
                color: 'light-primary',
                title: data['counter.product.scip-notifications.succeeded'].data,
                subtitle: this.$t('Component(Statistics):counter.product.scip-notifications.succeeded'),
                customClass: 'mb-0 mb-sm-0',
            });

            this.counters.push({
                key: 'counter.product.total',
                icon: 'BoxIcon',
                color: 'light-info',
                title: data['counter.product.total'].data,
                subtitle: this.$t('Component(Statistics):counter.product.total'),
                customClass: 'mb-0 mb-sm-0',
            });

            this.counters.push({
                key: 'counter.product.purchased',
                icon: 'BoxIcon',
                color: 'light-info',
                title: data['counter.product.purchased'].data,
                subtitle: this.$t('Component(Statistics):counter.product.purchased'),
                customClass: 'mb-0 mb-sm-0',
            });

            this.counters.push({
                key: 'counter.product.contains.svhc.total',
                icon: 'BoxIcon',
                color: 'light-danger',
                title: data['counter.product.contains.svhc.total'].data,
                subtitle: this.$t('Component(Statistics):counter.product.contains.svhc.total'),
                customClass: 'mb-0 mb-sm-0',
            });
        }
    },
    created() {
        const promises = [];
        promises.push(StatisticsApi.getCounters().then(response => {
            this.formGeneralCounters(response.data);
            this.formRequestVerticalCounters(response.data);
            this.formSupplierVerticalCounters(response.data);
            this.substanceProductCountData = response.data['aggregate.substance.product.count'];
        }));

        Promise.all(promises).then(() => {
            this.showLoading = false;
        });
    }
}
</script>

<template>
    <Overlay :show="showLoading">
        <b-row>
            <b-col>
                <CountersCard :counters="counters"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <VerticalCounterCard
                    :label="$t('Component(Statistics):label-product-requests-counters')"
                    :counters="requestVerticalCounters"
                />
            </b-col>
            <b-col>
                <VerticalCounterCard
                    :label="$t('Component(Statistics):label-suppliers-counters')"
                    :counters="supplierVerticalCounters"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <SubstanceProductCountTableCard
                    :metric="substanceProductCountData"
                />
            </b-col>
        </b-row>
    </Overlay>
</template>
